let items = document.querySelectorAll(".header__inline-menu details");

items.forEach(item => {
  let openTimeout, closeTimeout;

  const openMenu = () => {
    clearTimeout(closeTimeout);
    openTimeout = setTimeout(() => {
      item.setAttribute("open", true);
    }, 160);
  };

  const closeMenu = () => {
    clearTimeout(openTimeout);
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 320);
  };

  item.addEventListener("mouseenter", openMenu);
  item.addEventListener("focus", openMenu);
  item.addEventListener("mouseleave", closeMenu);
  item.addEventListener("blur", closeMenu);
});